import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/homeData';

export default function TestimonialsSection() {
  const { t } = useTranslation();

  const avatarUrls: Record<string, string> = {
    'avatar-sarah': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20woman%20with%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20friendly%20confident%20expression%2C%20clean%20minimalist%20portrait%20style%2C%20outdoor%20volunteer%20look&width=80&height=80&seq=avatar-sarah-m&orientation=squarish',
    'avatar-marcus': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20with%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20friendly%20genuine%20smile%2C%20clean%20minimalist%20portrait%20style%2C%20community%20leader%20look&width=80&height=80&seq=avatar-marcus-m&orientation=squarish',
    'avatar-elena': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20woman%20with%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20approachable%20smile%2C%20clean%20minimalist%20portrait%20style%2C%20environmental%20advocate&width=80&height=80&seq=avatar-elena-m&orientation=squarish',
    'avatar-david': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20with%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20friendly%20expression%2C%20clean%20minimalist%20portrait%20style%2C%20casual%20volunteer%20look&width=80&height=80&seq=avatar-david-m&orientation=squarish',
    'avatar-jennifer': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20woman%20with%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20bright%20genuine%20smile%2C%20clean%20minimalist%20portrait%20style%2C%20donor%20look&width=80&height=80&seq=avatar-jennifer-m&orientation=squarish',
    'avatar-tom': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20with%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20friendly%20approachable%20expression%2C%20clean%20minimalist%20portrait%20style%2C%20educator%20look&width=80&height=80&seq=avatar-tom-m&orientation=squarish',
  };

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-accent-700 bg-accent-100 rounded-full">
            {t('testimonials.tag')}
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-bold font-heading text-foreground-950 max-w-md leading-tight">
            {t('testimonials.title')}
          </h2>
        </div>

        {/* Masonry Grid - 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {/* Column 1 */}
          <div className="flex flex-col gap-5 md:gap-6">
            <TestimonialCard item={testimonials[0]} avatarUrl={avatarUrls['avatar-sarah']} />
            <TestimonialCard item={testimonials[3]} avatarUrl={avatarUrls['avatar-david']} />
          </div>
          {/* Column 2 */}
          <div className="flex flex-col gap-5 md:gap-6">
            <TestimonialCard item={testimonials[1]} avatarUrl={avatarUrls['avatar-marcus']} />
            <TestimonialCard item={testimonials[4]} avatarUrl={avatarUrls['avatar-jennifer']} />
          </div>
          {/* Column 3 */}
          <div className="flex flex-col gap-5 md:gap-6">
            <TestimonialCard item={testimonials[2]} avatarUrl={avatarUrls['avatar-elena']} />
            <TestimonialCard item={testimonials[5]} avatarUrl={avatarUrls['avatar-tom']} />
          </div>
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ item, avatarUrl }: { item: typeof testimonials[0]; avatarUrl: string }) {
  return (
    <div className="p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/60">
      {/* Author */}
      <div className="flex items-center gap-3 mb-4">
        <img
          src={avatarUrl}
          alt={item.name}
          className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover"
          title={item.name}
        />
        <div>
          <p className="text-sm font-semibold text-foreground-950">
            {item.name}
          </p>
          <p className="text-xs text-foreground-500">
            {item.role}
          </p>
        </div>
      </div>

      {/* Content */}
      <p className="text-xs md:text-sm text-foreground-700 leading-relaxed italic">
        &ldquo;{item.content}&rdquo;
      </p>
    </div>
  );
}